const Modal = ({
  isOpen=false,
  onClose=()=>{},
  children,
  className = "scale-100 w-[70%]",
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
      <div
        className={`bg-white dark:bg-slate-800 p-6 rounded-xl shadow-xl animate-fadeIn ${className}`}
      >
        {children}

        <div className="flex justify-end mt-6">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-gray-400 hover:bg-gray-500 rounded-lg"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default Modal;
